import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { RiLogoutCircleRLine } from "react-icons/ri";
import { Link, useLocation } from 'react-router-dom';
import { logoutHandler } from '../../Utils/Helper';
import './Sidebar.css';
import { MdOutlineClose } from 'react-icons/md';

const Sidebar = ({ dashboardSidebar }) => {
    const { pathname } = useLocation();

    const [show, setShow] = useState(false);

    const modal = <Modal show={show} centered className='logout_modal'>
        <Modal.Header onHide={() => setShow(false)}>
            <h5>Are you sure ?</h5>
            <MdOutlineClose onClick={() => setShow(false)} style={{ cursor: "pointer", fontSize: "22px" }} />
        </Modal.Header>
        <Modal.Body>
            <h3>Are you sure you want to logout?</h3>
            <div className='d-flex justify-content-center' style={{ gap: "20px" }}>
                <button className='no_btn' onClick={() => setShow(false)}>No</button>
                <button onClick={logoutHandler}>Yes</button>
            </div>
        </Modal.Body>
    </Modal>

    return (
        <div className='sidebar_main'>
            {modal}
            <ul>
                {
                    dashboardSidebar?.map((s) => {
                        return (
                            <li key={s.title} className={pathname?.split('/')[2] === s?.path?.split("/")[2] ? 'side_active' : ''}>
                                <Link to={s?.path?.length > 0 ? s.path : ''}>
                                    {s.icon}
                                    <span>{s.title}</span>
                                </Link>
                            </li>
                        )
                    })
                }
                <li onClick={() => setShow(true)} className='logout_btn' style={{color: "red"}}>
                    <RiLogoutCircleRLine />
                    <span>Logout</span>
                </li>
            </ul>
        </div>
    )
}
export default Sidebar;